export const environment = {
  production: false,
  apiBaseUrl: 'https://localhost:7182',
  tipoSaas: 3
};
export default environment;
